<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-text-field
                    label="期刊"
                    v-model="value.publication"
                    append-icon="search"
                    @click:append="() => dialog = true "
                    @click="() => dialog = true"
                    :rules="rules.required"
                    readonly
            />
        </v-flex>

        <v-flex xs2>
            <v-text-field
                    label="级别"
                    v-model="value.levelName"
                    disabled
            />
        </v-flex>

        <v-flex xs10>
            <v-text-field
                    label="检索情况"
                    v-model="value.indexNames"
                    disabled
            />
        </v-flex>

        <v-dialog
                v-model="dialog"
                persistent
                scrollable
                width="650"
        >
            <v-card>
                <v-card-text>
                    <p class="blue--text body-2">1.如果论文发表期刊在目录中，请选择检索并选择。</p>
                    <v-text-field
                            label="按期刊名称检索"
                            hide-details
                            v-model="journalSearch"
                            append-icon="search"
                            @click:append="onJournalSearch"
                            @keyup.enter="onJournalSearch"
                    />
                    <v-data-table
                            class="dense"
                            :headers="headers"
                            :items="journalItems"
                            :loading="journalLoading"
                            hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <td>
                                <v-checkbox
                                        v-model="journal"
                                        primary
                                        hide-details
                                        :key="props.item.dbid"
                                        :value="props.item.dbid"
                                        @click.native.stop="journalOther = null"
                                />
                                <!--:label="props.item.name"-->
                            </td>
                            <td>{{ props.item.name }}
                                <br/>
                                <span
                                        class="grey--text"
                                        v-if="props.item.issn && props.item.issn.trim().length > 0">
                                            {{props.item.issn}}&nbsp;
                                </span>
                                <span
                                        v-if="props.item.sponsors && props.item.sponsors.trim().length > 0"
                                        class="grey--text">
                                            {{props.item.sponsors}}
                                </span>
                            </td>
                            <td>{{ props.item.level? props.item.level.name: props.item.levelId }}</td>
                            <td>{{ props.item.indexings.map(v=> v.name).join(', ')}}</td>
                            <td>{{ props.item.version.name }}</td>
                        </template>
                        <template slot="footer">
                            <td colspan="100%" style="text-align: right">
                                <span v-if="journalTotal">共有{{journalTotal}}条记录，</span>
                                显示前 {{ journalLimit || 10}} 行数据。
                            </td>
                        </template>
                    </v-data-table>

                    <p class="blue--text body-2">2.如果论文发表期刊未在目录中，请选择以下类别，并填写期刊名称。</p>
                    <div class="px-4">
                        <v-checkbox
                                v-for="j in journalOtherItems"
                                v-model="journalOther"
                                :key="j.dbid"
                                :label="`${j.name},${j.subject.name},${j.level.name},${j.indexing.name}`"
                                :value="j.dbid"
                                hide-details
                                @click.native.stop="journal=null"
                        />

                        <v-text-field
                                label="期刊名称"
                                v-model="journalOtherName"
                                :rules="rules.journalOtherName"
                        />
                    </div>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.native="dialog = false">取消</v-btn>
                    <v-btn color="primary" :disabled="!(journal || journalOther)" @click.native="onOk">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-layout>
</template>
<script>
    const journalURI = '/api/papr/journal/';
    const journalOtherURI = '/api/papr/journal-other/';

    // const indexingURI = '/api/papr/indexing/';
    // const levelURI = '/api/papr/level/';

    export default {
        name: 'paperAuthor',
        props: ['value', 'label', 'hint', 'pubDate'],

        data() {
            return {
                dialog: false,
                item: {
                    journalId: null,
                    publication: null,
                    levelId: null,
                    indexIds: [],

                    levelName: null,
                    indexNames: null
                },

                journalSearch: '',
                journalLoading: false,
                journal: null,
                journalItems: [],
                journalTotal: null,
                journalLimit: null,

                journalOther: null,
                journalOtherName: '',
                journalOtherItems: [],

                headers: [
                    {text: '', sortable: false, value: 'dbid', width: 16},
                    {text: '名称 / ISSN, 主办单位', sortable: false, value: 'name'},
                    {text: '级别', sortable: false, value: 'level'},
                    {text: '索引情况', sortable: false, value: 'indexings'},
                    {text: '版本', sortable: false, value: 'version', width: 100},
                ],

                formValid: false,

                rules: {
                    required: [v => !!v || '该项必填'],
                    journalOtherName: [
                        v => (!this.journalOther || !!v) || '该项必填'
                    ]
                }
            }
        },

        created() {
            this.axios.all([
                //this.axios.get(indexingURI, {params: {limit: 65535, sort: 'order.asc'}}),
                //this.axios.get(levelURI, {params: {limit: 65535, sort: 'order.asc'}}),
                this.axios.get(journalOtherURI, {params: {limit: 65535, sort: 'order.asc'}}),
            ]).then(
                this.axios.spread(
                    (
                        //rspIndex, rspLevel,
                        rspOther) => {
                        // this.indexItems = rspIndex.data.items;
                        // this.levelItems = rspLevel.data.items;
                        this.journalOtherItems = rspOther.data.items;
                    }
                )
            )
        },

        watch: {
            // value: function (nv) {
            //   window.console.log(nv);
            //
            //   ['journalId', 'publication', 'levelId', 'indexIds'].forEach(v => this.item[v] = nv[v]);
            //
            //   if (nv.levelName) {
            //     this.item.levelName = nv.levelName;
            //   }
            //   if (nv.indexNames) {
            //     this.indexItems = nv.indexItems;
            //   }
            // }
        },

        methods: {
            onJournalSearch() {
                this.journalLoading = true;
                this.journal = null;
                this.axios
                    .get(journalURI, {
                        params: {
                            versionDisabled: 'F',
                            pubDate: this.pubDate,
                            limit: 10,
                            name: this.journalSearch && this.journalSearch.trim()
                        }
                    })
                    .then(rsp => {
                        this.journalItems = rsp.data.items;
                        this.journalLoading = false;

                        this.journalTotal = rsp.data.total;
                        this.journalLimit = rsp.data.limit;
                    })
            },

            onOk() {
                if (this.journal) {
                    const jour = this.journalItems.find((v) => v.dbid === this.journal);
                    this.item.journalId = this.journal;
                    this.item.publication = jour.name;
                    this.item.levelId = jour.levelId;
                    this.item.indexIds = jour.indexings.map(v => v.dbid);

                    this.item.levelName = jour.level.name;
                    this.item.indexNames = jour.indexings.map(v => v.name).join(', ');

                } else if (this.journalOther) {
                    const jour = this.journalOtherItems.find((v) => v.dbid === this.journalOther);
                    this.item.journalId = null;
                    this.item.publication = this.journalOtherName;
                    this.item.levelId = jour.levelId;
                    this.item.indexIds = [jour.indexId];

                    this.item.levelName = jour.level.name;
                    this.item.indexNames = jour.indexing.name;
                }

                this.$emit('input', window.xutil.clone(this.item));
                this.dialog = false;
            }
        }

    }
</script>
<style>
    .authors.v-toolbar > .v-toolbar__content {
        padding-left: 0;
    }
</style>

